$(document).on('turbo:load turbo:render', () => {
    // if ($('.expandable-form').length) {
    //     let toggled = false;
    //     let $qualifying_form = $('fieldset').first();
    //     let $toggles = $qualifying_form.find('input[type="radio"][value="true"]');
    //     $toggles.on('change', ()=> {
    //         if (!toggled) {
    //             let $interest = $(document).find('.expandable-form').first();
    //             $interest.addClass('show');
    //             $interest.trigger('show.bs.collapse');
    //             toggled = true;
    //         }
    //         $toggles.off('change');
    //     });
    //
    // }

    $(document).find(".expandable-form.show").trigger('lazyReveal');

});